import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-header-mask',
  templateUrl: './header-mask.component.html',
  styleUrls: ['./header-mask.component.css']
})
export class HeaderMaskComponent implements OnInit {

  constructor(private _router:Router) { }

  ngOnInit() {
  }

  showMe(): boolean {

    let index = ["/", "/signin", "/signup"].findIndex(item => item === this._router.url)

    return index >= 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/header-mask/header-mask.component.ts